namespace RioERP.Masters {
    export namespace SmsTemplateVariablesService {
        export const baseUrl = 'Masters/SmsTemplateVariables';

        export declare function Create(request: Serenity.SaveRequest<SmsTemplateVariablesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SmsTemplateVariablesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SmsTemplateVariablesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SmsTemplateVariablesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/SmsTemplateVariables/Create",
            Update = "Masters/SmsTemplateVariables/Update",
            Delete = "Masters/SmsTemplateVariables/Delete",
            Retrieve = "Masters/SmsTemplateVariables/Retrieve",
            List = "Masters/SmsTemplateVariables/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SmsTemplateVariablesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
